<template>
    <div
        v-if="siteData && siteData.organizerLogo && !siteData.alternativeOrganizer"
        class="img-container">
        <img
            class="img"
            :src="siteData.organizerLogo"
            :alt="siteData.organizerName">
    </div>
</template>

<script>
import mainSiteMixin from "@/mixins/mainSiteMixin";

export default {
    name: "AnbieterLogo",
    mixins: [mainSiteMixin]
}
</script>

<style scoped>
.img-container {
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>